import { CookieConsentService } from "./cookie-consent.js";
import { GoogleScriptsService, FacebookScriptsService, BingScriptsService } from "./tracking-scripts.js";

declare var cookieBannerParams: any;

window.addEventListener('load', function () {
    CookieConsentService.CookieConsentKey = cookieBannerParams.CookieConsentKey;
    CookieConsentService.EnableImpliedCookieConsent = cookieBannerParams.EnableImpliedCookieConsent;
    CookieConsentService.clearAllCookiesIfConsentNotGiven();

    CookieBanner_BindEvents();
})

function acceptAllCookies() {
    CookieConsentService.onManuallyConsentToAllCookies();
    GoogleScriptsService.consentGranted();
    //FacebookScriptsService.addFacebookTracking();
    //FacebookScriptsService.addFacebookEvent("search");
    if (cookieBannerParams.RenderDDASalesEventSnippetPaymentAmountHasValue) {
        GoogleScriptsService.addConversionPage((cookieBannerParams.RenderDDASalesEventSnippetPaymentAmount.Value.ToString("f2")));
    }

    document.getElementById("cookieConsentOptional")!.setAttribute("checked", "true");
    toggleHidden();
}

function getCookieBanner() {
    return document.getElementsByClassName('cookie-banner')!.item(0)! as HTMLElement;
}

function toggleHidden() {
    var cookieBanner = getCookieBanner();
    if (!cookieBanner.classList.contains("hidden")) {
        cookieBanner.classList.toggle("hidden");
    }
};

function hideCustomiseCookiesModal() {
    (window as any).ARIAmodal.closeModal();
}

function showCustomiseCookiesModal() {
    var modal = document.getElementById("customiseCookiesModal")!;
    modal.style.display = "block";
}

function CookieBanner_BindEvents() {
    if (CookieConsentService.shouldShowCookieBanner()) {
        var cookieBanner = getCookieBanner();
        if (cookieBanner.classList.contains("hidden")) {
            cookieBanner.classList.remove("hidden");
        }
    } else {
        toggleHidden();
    }

    var customiseCookies = document.getElementById("customiseCookies");
    if (customiseCookies) {
        customiseCookies.addEventListener("click", function () {
            showCustomiseCookiesModal();
            if (cookieBannerParams.TargetIsMobile) {

                getCookieBanner().style.zIndex = "-1";
            }
        });
    }

    var manageCookieConsent = document.querySelectorAll('[data-id=manageCookieConsent]');

    if (manageCookieConsent && manageCookieConsent!.item(0)) {
        manageCookieConsent!.item(0)!
            .addEventListener("click", function () {
                showCustomiseCookiesModal();
                getCookieBanner().style.zIndex = "-1";
            });
    }
     

    document.querySelectorAll('[id=buttonAcceptAllCookiesConsent]')!.item(0)!
        .addEventListener("click", function () {
            acceptAllCookies();
            hideCustomiseCookiesModal();
        });

    document.getElementById("buttonCookieConsent")!
        .addEventListener("click", function () {
            acceptAllCookies();
            hideCustomiseCookiesModal();
        });

    document.getElementById("buttonSelectedCookiesConsent")!
        .addEventListener("click", function () {
            hideCustomiseCookiesModal();
            toggleHidden();
            if (document.getElementById("cookieConsentOptional")!.getAttribute("checked")) {
                acceptAllCookies();
            }
            else {
                CookieConsentService.onManuallyConsentToEssentialCookies();
                GoogleScriptsService.consentRevoked();
            }
        });
}